export const SERVICE_CATEGORIES = [
  'Food', 'Relocation', 'Cleaning', 'Babysitting', 'Tutoring', 'Repair',
  'Translation', 'Beauty', 'Fitness', 'PetCare', 'TechSupport', 'Other',
] as const;

export const SERVICE_EMOJI: Record<string, string> = {
  Food: '🍱', Relocation: '📦', Cleaning: '🧹', Babysitting: '👶',
  Tutoring: '📖', Repair: '🔨', Translation: '🌐', Beauty: '💄',
  Fitness: '💪', PetCare: '🐾', TechSupport: '💻', Other: '🛠️',
};

export const SERVICE_GRADIENT: Record<string, string> = {
  Food:        'linear-gradient(135deg, #f97316 0%, #7c2d12 100%)',
  Relocation:  'linear-gradient(135deg, #3b82f6 0%, #1e3a8a 100%)',
  Cleaning:    'linear-gradient(135deg, #06b6d4 0%, #164e63 100%)',
  Babysitting: 'linear-gradient(135deg, #f59e0b 0%, #78350f 100%)',
  Tutoring:    'linear-gradient(135deg, #8b5cf6 0%, #4c1d95 100%)',
  Repair:      'linear-gradient(135deg, #64748b 0%, #0f172a 100%)',
  Translation: 'linear-gradient(135deg, #10b981 0%, #064e3b 100%)',
  Beauty:      'linear-gradient(135deg, #ec4899 0%, #500724 100%)',
  Fitness:     'linear-gradient(135deg, #ef4444 0%, #7f1d1d 100%)',
  PetCare:     'linear-gradient(135deg, #84cc16 0%, #365314 100%)',
  TechSupport: 'linear-gradient(135deg, #6366f1 0%, #1e1b4b 100%)',
  Other:       'linear-gradient(135deg, #475569 0%, #0f172a 100%)',
};
